module.exports = __webpack_public_path__ + "img/73.150f42e7.jpg";